<template>
  <div class="section-container">
    <section-title
      class="section-container__section-title"
      :container-class="
        sectionData.customTitle
          ? 'section-container__section-title__container'
          : undefined
      "
      :has-line="!sectionData.customTitle"
      :icon="sectionData.customTitle ? 'fas fa-file-user' : undefined"
      :title="sectionData.title"
      title-class="section-container__section-title__info"
    />
    <div class="bg-secondary-3 p-2 row m-0 rounded">
      <div class="col-12 col-md-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="section.date"
            :custom-error-msg="sectionData.dateErrorMsg"
            :disabled="sectionData.disabledDatePicker || readOnly"
            :error="errors[0]"
            :label="sectionData.dateLabel"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div v-if="sectionData.hasHourInput" class="col-12 col-md-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-time-picker
            v-model="section.hour"
            class="custom-datetime-picker-container"
            :custom-error-msg="sectionData.hourErrorMsg"
            :disabled="readOnly"
            :error="errors[0]"
            label="Hora:"
            placeholder="HH:mm"
          />
        </validation-provider>
      </div>
      <div
        v-for="(comment, idx) of section.comments"
        :key="idx"
        class="col-12 mt-3"
      >
        <validation-provider
          v-slot="{ errors }"
          :rules="idx == 0 ? 'required' : ''"
        >
          <custom-text-area
            id="comment"
            v-model="section.comments[idx]"
            class="section-container__text-area"
            :count-classes="['d-block', 'small-counter']"
            :custom-error-msg="sectionData.textErrorMsg"
            :disabled="readOnly"
            :error="errors[0]"
            :label="sectionData.textAreaLabel"
            :maxlength="3000"
            name="comment"
            show-char-count
          />
        </validation-provider>
      </div>
    </div>
    <div
      v-if="sectionData.multipleTextArea && !readOnly"
      class="d-flex justify-content-end my-3"
    >
      <action-button
        i="fas fa-file-plus"
        responsive
        text="Añadir"
        variant="success"
        @click="addSection"
      />
    </div>
    <div v-if="showSecondTextInput" class="bg-secondary-3 px-4 py-2 rounded">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-text-area
          id="comment"
          v-model="section.subComments"
          class="section-container__text-area"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="sectionData.subErrorMsg"
          :disabled="readOnly"
          :error="errors[0]"
          :label="sectionData.subSectionTitle"
          :maxlength="3000"
          name="comment"
          show-char-count
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomTimePicker from 'custom-time-picker';

export default {
  name: 'AdmissionNoteSection',
  components: {
    SectionTitle,
    CustomTextArea,
    ActionButton,
    CustomDatePicker,
    CustomTimePicker,
  },
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    section: {
      date: null,
      hour: null,
      comments: [''],
      subComents: null,
    },
  }),
  computed: {
    showSecondTextInput() {
      return this.sectionData.subSectionTitle?.length != undefined;
    },
  },
  watch: {
    sectionData: {
      immediate: true,
      handler(current) {
        if (current.data) {
          this.section = { ...current.data };
        }
      },
    },
  },
  methods: {
    addSection() {
      this.section.comments.push('');
    },
    getValues() {
      for (var propName in this.section) {
        if (
          this.section[propName] === null ||
          this.section[propName] === undefined ||
          this.section[propName] === ''
        ) {
          delete this.section[propName];
        }
      }
      return this.section;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.section-container {
  margin-top: 2rem;
  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }
}
</style>
